if($('.type-detail').length){
    if($('.price-measure').text().trim().length){
        $('.p-info-wrapper').addClass('konfig')
        var zaokrouhleni = $('.p-info-wrapper .add-to-cart .amount').attr('data-decimals')
        var cenasdph = $('.price-measure').html()
        var naseCenaSDPH = $('.p-final-price-wrapper .price-final-holder').html()
        var mernaJednotka = $('.p-final-price-wrapper .price-final-holder .pr-list-unit').html()
        var mernaJednotkaSplit = mernaJednotka.split('/')[1].trim()
        var cenazabaleni = parseFloat($('.p-final-price-wrapper .price-final-holder').text().split('/')[0].replace(',', '.').replace(/ /g, ''))
        var cenabezdph = cenazabaleni/1.21
        var obshabaleni = $('.p-info-wrapper .add-to-cart .amount').attr('min')
        var unit = $('.price-measure').text().trim().split('/')[1].replace(/\d+/g, '').trim()
        var tretiMernaJednotka = $('.detail-parameters tr th:contains("Třetí měrná jednotka")').closest('tr').find('td').text()
        var cenaV = $('.detail-parameters tr th:contains("Cena v")').closest('tr').find('td').text()
        var jednotkaObsahu = $('.price-measure').text().trim().split('/')[1].trim()

        var text = jednotkaObsahu;
        var parts = text.split(/\s+/); // Rozdělení textu na části podle mezery
        if (parts.length > 1) {
          var unit = parts[1]; // Získání druhé části (v tomto případě "m2")
          
        }
        
        var kalkulator = '<div class="calc">'
            kalkulator += '<div class="left">'
            if($('.p-final-price-wrapper .price-standard').length){
                var slevnenacena = $('.p-final-price-wrapper .price-standard').text().trim()
                kalkulator += '<div class="calc-row"><span class="left">Celková cena s DPH:</span><span class="right sleva">'+slevnenacena+'</span></div>'
            }
                kalkulator += '<div class="calc-row"><span class="left">Naše cena s DPH:</span><span class="right red"><strong>'+naseCenaSDPH+'</strong></span></div>'
                kalkulator += '<div class="calc-row"><span class="left">Naše cena s DPH:</span><span class="right"><strong>'+Number(Math.round(cenazabaleni*obshabaleni)).ShoptetFormatAsCurrency()+' <span class="pr-list-unit">/ '+cenaV+'</span></strong></span></div>'
                kalkulator += '<div class="calc-row"><span class="left">Naše cena bez DPH:</span><span class="right">'+Number(Math.round(cenabezdph*obshabaleni)).ShoptetFormatAsCurrency()+' / '+cenaV+'</span></div>'
                kalkulator += '<div class="calc-row"><span class="left">Obsah balení:</span><span class="right">'+obshabaleni+' '+unit+'</span></div>'
            kalkulator += '</div>'
            kalkulator += '<div class="right">'
                kalkulator += '<h2>Orientační výpočet:</h2>'
                kalkulator += '<div class="calc-row"><span class="left">Kolik '+tretiMernaJednotka+' potřebujete:</span><span class="right"><input id="inputNumber" type="number" min="0"></span></div>'
                kalkulator += '<div class="calc-row"><span class="left">Dodáme:</span><span class="right"><span class="vypocet-dodame"></span> '+cenaV+'</span></div>'
                kalkulator += '<div class="calc-row"><span class="left">Cena:</span><span class="right"><span class="vypocet-cena"></span></span></div>'
            kalkulator += '</div>'
        kalkulator += '</div>'
        $('.p-info-wrapper').append(kalkulator)
        $('.add-to-cart .quantity').after('<div class="unit">'+$('.p-final-price-wrapper .pr-list-unit').text().replace('/', '').trim()+'</div>')
        $("#inputNumber").on("change keyup", function() {
            var newValue = $(this).val();
            updateResult(newValue);
        });
        function updateResult(value) {
            setTimeout(function(){
                var spotrebaNaJednotku = parseFloat($('.detail-parameters tr th:contains("Spotřeba na měrnou jednotku")').closest('tr').find('td').text())
                var potrebuji = Math.ceil((value*spotrebaNaJednotku)/obshabaleni)
                var Spotreba = potrebuji*obshabaleni
                $('.vypocet-dodame').html(potrebuji)
                $('.vypocet-cena').html((cenazabaleni*Spotreba).ShoptetFormatAsCurrency())
                $('.add-to-cart input.amount').val(potrebuji*obshabaleni).text(potrebuji*obshabaleni)
            }, 100)
           
        }
    }
    

}